import "core-js/modules/es6.regexp.match.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { version } from "../../../package.json";
export default {
  name: 'Settings',
  components: {
    FibDefaultSurvey: require("./DefaultSurvey").default,
    FibDeviceSettings: require("./DeviceSettings").default,
    FibDownloadSurveys: require("./DownloadSurveys").default,
    FibManageTeam: require("../manageTeam/ManageTeam").default,
    FibResetDevice: require("./ResetDevice").default,
    FibUploadSurveys: require("./UploadSurveys").default,
    FibDownloadMenuItems: require("./DownloadMenuItems").default
  },
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data: function data() {
    return {
      showDefaultSurvey: false,
      showDeviceSettings: false,
      showDownloadSurveys: false,
      showManageTeam: false,
      showResetDevice: false,
      showUploadSurveys: false,
      updatingApp: false,
      showDownloadMenuItems: false,
      showStatusPwa: false,
      version: version
    };
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/baseTheme'];
    },
    messageColor: function messageColor() {
      return this.theme.secondaryColor;
    },
    deviceId: get('config/deviceId'),
    lastDownload: get('config/lastUpdated'),
    lastUpload: get('responses/lastUpdated'),
    loggedInMember: get('settings/loggedInMember'),
    appUpdateReady: get('app/GET_UPDATE_READY'),
    hasConnectivity: get('settings/hasConnectivity'),
    completedSurveys: get('responses/responsesTemp'),
    summary: get('surveys/summary'),
    isRunningStandalone: function isRunningStandalone() {
      var isInWebAppIOS = navigator.standalone === true;
      var isInWebAppChrome = window.matchMedia('(display-mode: standalone)').matches;
      var isStandalone = isInWebAppIOS || isInWebAppChrome;
      return Boolean(isStandalone);
    },
    isAPK: function isAPK() {
      var ua = navigator.userAgent;
      return Boolean(ua.match(/Android/i));
    },
    runningMode: function runningMode() {
      return this.isAPK ? 'apk' : this.isRunningStandalone ? 'pwa' : 'web';
    }
  },
  methods: {
    updateApp: function updateApp() {
      var _this = this;

      this.updatingApp = true;
      this.$store.dispatch('app/updateApp');

      if ((navigator || {}).serviceWorker) {
        navigator.serviceWorker.addEventListener('controllerchange', function () {
          if (_this.refreshing) {
            return;
          }

          sessionStorage.setItem('updatingApp', true);

          _this.$store.commit('app/SET_APP_REFRESHING', true);

          window.location.reload();
        });
      }
    }
  }
};